<form [formGroup]="targetForm" >
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Edit Expense Survey</h2>
        </div>
        <div class="drawer-close" (click)="closeRightSideDrawer()"><i class="fas fa-times" aria-hidden="true"></i></div>
    </header>
    <section class="sideRight-body">
        <label for="ei-surveyName" class="mt-2">
            Survey Name*
            <span *ngIf="f.expenseSurveyName.errors && (f.expenseSurveyName.touched || f.expenseSurveyName.dirty)">
                <span class="required-error" *ngIf="f.expenseSurveyName.errors.required">(required)</span>
            </span>
            <input class="black-input opposite-colors" placeholder="Survey Name" type="text" no-special-chars="#!$%^<>+='" (change)="checkChangeName()"
            (blur)="trimSpecialChar('expenseSurveyName');noWhitespaceValidator();" maxlength="100" (input)="isChanged();noWhitespaceValidator();" formControlName="expenseSurveyName" required />
        </label>
        <div class="form-error-sign" *ngIf="f.expenseSurveyName.errors">
            <p *ngIf="f.expenseSurveyName.errors.required || !f.expenseSurveyName.valid">Survey Name is required.</p>
        </div>

        <div class="add-user-block" >
            <label for="ei-location" *ngIf="expenseSurveyDetail.statusId !== 4"> Select SME*</label>
            <div class="hcne-kpmg-users">
        
           
                <span class="required-error" *ngIf="respondentSelected.length===0 && expenseSurveyDetail.statusId !== 4">(required)</span>
            
            <div class="input-with-icon mt-2">
                <div class="input-elm">
                <input class="champion-search-input" placeholder="Search SME" type="text" 
                    no-special-chars="#!$@%^<>+=" [inputFormatter]="respondentFormatter"
                    [kpmgUiTypeahead]="searchRespondents" [resultTemplate]="rt" [editable]="false" 
                    (selectItem)="onRespondentSelected($event)" [disabled]="expenseSurveyDetail.statusId===4"/>
                </div> 
               
                <ng-template #rt let-r="result" let-t="term"> 
                    <!-- <kpmg-ui-highlight *ngIf="adSME" [result]="r.userName" [term]="t">
                    </kpmg-ui-highlight>&nbsp;  -->
                    <kpmg-ui-highlight [title]="r.userName" *ngIf="adSME" [result]="r.displayName" [term]="t">
                    </kpmg-ui-highlight>&nbsp;
                    <kpmg-ui-highlight [title]="r.userName" *ngIf="!adSME" [result]="r.displayName" [term]="t"></kpmg-ui-highlight>
                </ng-template>
            </div>
           
        <div class="form-error-sign" *ngIf="respondentSelected.length===0 && expenseSurveyDetail.statusId !== 4">
            <p>SME is required.</p>
        </div>  

        <div *ngIf="respondentSelected.length > 0 && expenseSurveyDetail.statusId !== 4" class="mt-2">
            <ngx-datatable
              class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
              [rows]="respondentSelected" [headerHeight]="0" [rowHeight]="35"
              [ngStyle]="{'height': respondentSelected.length * 45 +'px' }">
              <ngx-datatable-column [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span class="link-button trash__btn" (click)="removeRespondent(row)" tabindex="1"
                    >
                    <i class="fas fa-times cross-i-style"></i>
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column prop="name" [width]="360">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.displayName}}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
          </div>
        </div>

        <div class="ei-reminder-frequency mt-2"> 

            <label for="ei-reminder-frequency">
                Email Reminder Frequency
                <span *ngIf='reminderValue > 0'>({{reminderValue}} Days)</span>
                    <span *ngIf='reminderValue === 0'>(No Reminder)</span>
                <br />
                <div class="slidecontainer">
                    <!-- <ngx-slider 
            [options]="emailReminderFrequencyOptions"
            [(value)]="reminderValue" 
            formControlName="reminderFrequency" 
            (userChange)="sliderEvent($event)"
            ></ngx-slider> -->
                 
                </div>
            </label> 
            <div class="form-warning-sign" *ngIf="f.reminderFrequency.value===0">
                <p class="mt-0">* Email reminders will not be sent if frequency is set to zero.</p>
            </div>
            <div class="form-error-sign" *ngIf="!f.reminderFrequency.valid">
                <p class="mt-0">Email Reminder Frequency should be between 0 and 10.</p>
            </div>
        </div>


        <div class="ei-dueDate mt-2">
            <label for="ei-dueDate">
                Due Date
                <span class="input-group duedate-input">
                    <input type="text" class="black-input opposite-colors" no-special-chars="#!$%^<>+='"
                        [minDate]="minDate" 
                        [bsValue]="expenseSurveyDetail.dueDate"
                        placeholder="MM/DD/YYYY" bsDatepicker
                        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                        formControlName="dueDate"  (bsValueChange)="setDueDate($event)"
                        #dpDueDate="bsDatepicker" style="opacity: 1;">
                    <span class="input-group-append" [ngClass]="{'block-datepicker-section' : isSmeUser}">
                        <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.dueDate"
                            (click)="clearDueDate()"></i>
                        <i class="fa fa-calendar-alt" (click)="openDatePickerEnd()"></i>
                    </span>
                </span>
            </label>
        </div>

    </section>

    
    <footer class="endFormSubmit info-tile">
        <button [disabled]="!targetForm.valid  || isDisabled || respondentSelected.length===0" type='button' class="btn btn-success" >Submit</button>
        <button class="btn kpmg-button--flat" (click)="closeRightSideDrawer()">Cancel</button>
    </footer>
</form>
